import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addCategory = catchAsync(async (body) => {
  const data = await axiosInstance.post("salon/service-categories", body);
  return data;
});

export const showCategory = catchAsync(
  async (categoryId, xTranslate = false) => {
    const { data } = await axiosInstance.get(
      `salon/service-categories/${categoryId}`,
      {
        headers: {
          "x-translations": xTranslate,
        },
      }
    );
    return data;
  }
);

export const deleteCategory = catchAsync(
  async (categoryId, without_services) => {
    const { data } = await axiosInstance.delete(
      `salon/service-categories/${categoryId}?without_services=${without_services}`
    );
    return data;
  }
);

export const editCategory = catchAsync(async (body) => {
  const data = await axiosInstance.put(
    `salon/service-categories/${body?.id}`,
    body
  );
  return data;
});

export const getAllCategories = catchAsync(async (params) => {
  const { data } = await axiosInstance.get("salon/service-categories", {
    params,
  });
  return data;
});
export const getProductsCategories = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/product-categories");
  return data;
});
